import { toggleMsgLoader } from '../store/actions'
import { changeButtonStartState, markAsAcknowledged, setOperatorPrinting, setUserAuthorizedStateAction, toggleConnectionAwaiting, updateWidgetSettingsAction, dropMessages, showNotification } from '../store/dispatcher'
import { SOCKET_URL, WIDGET_TOKEN, SERVER_URL, CONNECTION_ATTEMPTS_LIMIT } from "../constants";
import store from "../store";
import { getClientId, setClientId } from '../sessionStorage/room';
import { UserState, WidgetSettings } from '@types';
import { uuid } from '../utils/uuid';

let socket;

enum statuses {
    "CONNECTING",
    "STARTED"
}
interface MessageForSend {
    message_id: string,
    body: string,
    type: "message"
}

interface MessageAcknowledge {
    message_id: string,
    type: "acknowledged"
}
interface MessageForAccept {
    message: string,
    type: "message" | "error"
}

interface MessageForAuth {
    username: string,
    phone: string,
    type: "authorization",
    external_data: {}
}

type MessageFromServerAsText = {
    body: string,
    ivr_status?: "answer" | 'hangup',
    type: 'message' | 'authorization' | 'transcription',
    files: [],
    buttons: [],
    sender: 0 | 1
    created_at: number,
    sender_name?: string,
    message_id: string,
    acknowledged: boolean
}

type SetOperatorName = {
    type: 'set_operator_name',
    operator_name: string,
}

type MessageBot = {
    type: 'message_bot',
    body: string,
    ivr_status: null,
    files: [],
    buttons: []
}

type SettingsMessage = {
    type: 'settings',
    use_button: boolean,
}

type AcknowledgedMessage = {
    type: 'acknowledged',
    message_id: string,
}


type PrintStatusMessage = {
    type: 'operator_typing',
    is_typing: boolean,
    sender_id: number,
    sender_role?: number
}

type MessageFromServer = MessageFromServerAsText | {
    data: { messages: MessageFromServerAsText[], operator_name: string };
    type: 'history';
    unread?: number;
} | PrintStatusMessage | SetOperatorName | SettingsMessage | MessageBot | AcknowledgedMessage;

interface MessageFirst {
    url: string,
    token: string
}



class ChatSocket {
    SOCKET_URL: string;
    socket: WebSocket | null;
    status: statuses;
    room_id: string | null;
    client_id: string | null;
    awaitConnection: boolean;
    connectionAttempts: number;
    isWaitingTimeIsUp: boolean;
    timeoutForReconnection: number;
    senderName: string | null;
    isFirstConnection: boolean;

    handler: ((Object) => void) | null;

    constructor(url) {
        this.status = statuses.CONNECTING;
        this.handler = null;
        this.room_id = null;
        this.client_id = null;
        this.SOCKET_URL = url;
        this.socket = null;
        this.awaitConnection = false;
        this.connectionAttempts = 0;
        this.isWaitingTimeIsUp = false;
        this.timeoutForReconnection = 500;
        this.senderName = null;
        this.isFirstConnection = true;
    }

    connect(room_id: string, client_id: string) {
        const that = this;
        this.isWaitingTimeIsUp = false;
        if (!WIDGET_TOKEN) {
            throw new Error('Widget token is undefined. Check .env')
        }
        if (!SERVER_URL) {
            throw new Error('Widget SERVER_URL is undefined. Check .env')
        }

        if (!this.isFirstConnection) {
            showNotification('Попытка подключения к серверу...', 'info')
        }

        const firstMessage: MessageFirst = {
            token: WIDGET_TOKEN,
            url: SERVER_URL
        }

        this.awaitConnection = true

        let client_id_from_LS = getClientId()

        if (!client_id_from_LS) {
            setClientId(uuid())
            client_id_from_LS = getClientId()
        }

        const socket = new WebSocket(`${SOCKET_URL}/${client_id_from_LS}`);

        this.socket = socket;

        const connect = () => this.connect(room_id, client_id);
        const handler = this.handler ? this.handler : event => console.error("Message from socket without handler function: ", event);

        socket.onopen = () => {
            this.status = statuses.STARTED
            this.awaitConnection = false
            this.connectionAttempts = 0;
            socket.send(JSON.stringify(firstMessage))


            setTimeout(() => {
                toggleConnectionAwaiting(false)
                that.isWaitingTimeIsUp = false;

                // if (!that.isFirstConnection) {
                //     showNotification('Успешно подключились к серверу', 'success')
                // }
            }, 500)
        }

        socket.onerror = function (error) {
            console.dir(error);
            console.error(error);
            that.awaitConnection = false
            socket.close()
        };

        socket.onclose = () => {
            this.connectionAttempts++
            this.isFirstConnection = false
            if (!this.awaitConnection && !(this.connectionAttempts > CONNECTION_ATTEMPTS_LIMIT)) {
                setTimeout(() => {
                    this.timeoutForReconnection += 1000;
                    connect()
                }, this.timeoutForReconnection)

            } else {
                throw new Error('Connection failed. Check url and token')
            }
            this.awaitConnection = false
            toggleConnectionAwaiting(true)
            showNotification('Произошел разрыв соединения', 'error')
        }

        socket.onmessage = function (event) {
            const data = JSON.parse(event.data) as MessageFromServer;

            if (store.getState().behavior.messageLoader) {
                toggleMsgLoader()
            }
            try {
                if (data.type === 'history') {
                    if (that.isWaitingTimeIsUp) {
                        return
                    }
                    dropMessages()
                    handler(data)
                    setUserAuthorizedStateAction(true)
                    changeButtonStartState(false)
                    that.senderName = data.data.operator_name
                    if (!that.isFirstConnection) {
                        showNotification('Обновили историю диалога', 'success')
                    }
                    return
                }

                if (data.type === 'operator_typing') {
                    setOperatorPrinting(data.is_typing)
                    return
                }

                if (data.type === 'set_operator_name') {
                    that.senderName = data.operator_name
                    return
                }

                if (data.type === 'settings') {
                    const settings: WidgetSettings = { use_button: data.use_button };
                    updateWidgetSettingsAction(settings);
                    return;
                }

                if (data?.type === 'acknowledged') {
                    markAsAcknowledged(data.message_id)
                    return;
                }

                if (data?.ivr_status === 'hangup') {
                    // changeButtonStartState(true)
                }

                if (data.body === '' && !data.files?.length) return;

                if (data.type === 'message_bot') {
                    handler({ ...data, sender_name: 'Бот', type: 'message' })
                } else {
                    handler({ ...data, sender_name: that.senderName })
                    that.acknowledge(data.message_id)
                }


            } catch (error) {
                console.error('Error in handler: ', event)
            }
        };
        return socket
    }

    reconnectToNew() {
        this.socket?.close();
        const newClientId = Math.random().toString().slice(2);
        setClientId(newClientId);
        this.client_id = newClientId;
        this.socket = this.connect('', newClientId);
    }

    acknowledge(messageId: string) {
        const messageObject: MessageAcknowledge = { message_id: messageId, type: "acknowledged" }

        if (this.socket) {
            this.socket.send(JSON.stringify(messageObject))
        } else {
            console.error("Couldn't confirm message:", messageId);
        }
    }

    public subscribe(handler: (data: MessageFromServer) => any) {
        this.handler = handler
    }

    public authorization(userData: UserState['userData']) {
        if (this?.socket) {
            const messageForAuth: MessageForAuth = {
                username: userData.userName,
                phone: userData.phone,
                type: 'authorization',
                external_data: userData
            }
            this.socket.send(JSON.stringify(messageForAuth))
            // this.sendMessage('Вы нажали начать новый диалог')
            changeButtonStartState(false)
        }
    }

    public async sendMessage(messageId: string, body: string) {

        const messageObject: MessageForSend = { message_id: messageId, type: "message", body }

        if (this.socket) {

            // temp
            // @ts-ignore
            if (body instanceof Blob) {
                this.socket.binaryType = "arraybuffer";

                const arrayBufferMessage = await body.arrayBuffer()

                this.socket.send(arrayBufferMessage)
            } else {
                // console.log('sendingMessage string', message);
                this.socket.send(JSON.stringify(messageObject))
            }

            // temp

            // @ts-ignore
            // this.socket.send(JSON.stringify({
            //     "content": message,
            //     "datetime": new Date(),
            //     "type": "message"
            // }));

            // if(this.socket){
            //     console.log('sendingMessage', message);

            //     this.socket.send(JSON.stringify({
            //         "content": message,
            //         "datetime": new Date(),
            //         "type" : "message"
            //     }));
        } else {
            console.error("Message from socket without socket connections: ", body);
        }
    }

}

export default new ChatSocket(`${SOCKET_URL}`);
